import FragmentDataType from "../enums/fragment-data-type";
import EndOfPlay from "./end-of-play";

export default class CollectDriveTime extends EndOfPlay {
    constructor(time) {
        super();
        this.time = time;
        this.requiredData = [
            {
                name: "time",
                type: FragmentDataType.Time,
                displayName: "Play Time",
                title: "Play Time",
                subtitle: () => "What time did this play end?",
                isEditable: true
            }
        ];
    }
}
